import { render, staticRenderFns } from "./tzltgzb.vue?vue&type=template&id=238c4851&scoped=true&"
import script from "./tzltgzb.vue?vue&type=script&lang=js&"
export * from "./tzltgzb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238c4851",
  null
  
)

export default component.exports